
import { Component, Vue, Prop } from "vue-property-decorator";
import BaseCard from "@/components/base/BaseCard.vue";
import FormModal from "@/components/base/FormModal.vue";
import { IBaseAutocomplete } from "@/types";
import { getActiveUserSearch } from "@/api/user";
import { Advertiser } from "@/services/advertiser/Advertiser";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import { IAdvertiserManagers } from "@/api/types/revenue";
import { eventBus } from "@/eventbus";
import { ITableHeader } from "@/utils";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgTrash from '@/assets/icons/trash.svg';
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import SvgPlus from "@/assets/icons/plus.svg";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import BaseList from "@/components-UI/list/BaseList.vue";

@Component({
    components: {
        SvgPlus,
        BaseEditableCard,
        BaseButton,
        BaseAutocomplete,
        FormModal,
        BaseCard,
        BaseTable,
        SvgTrash,
        BaseListItem,
        BaseList,
    },
})

export default class AdditionalManagers extends Vue {
    @Prop({ required: true }) advertiser!: Advertiser;
    @Prop() disableTitleButton!: boolean;

    isShowModal: boolean = false;
    isShowDeleteModal: boolean = false;
    isLoading: boolean = false;
    managerId: number | null = null;
    managerName: string = '';
    headers: ITableHeader[] = [
        { text: 'Имя', value: 'first_name', width: 'auto' },
        { text: 'Фамилия', value: 'last_name', width: 'auto' },
        { text: '', value: 'actions', align: 'center', width: '30px' },
    ];
    config: RawConfig<any> = {
        [CellsType.Text]: {
            first_name: {
                template: (i) => i.user.first_name,
            },
            last_name: {
                template: (i) => i.user.last_name,
            },
        },
        [CellsType.Uniq]: {
            actions: {},
        },
    };

    get getFormatedItems(): any {
        const columns = this.headers.map(el => el.value);
        return prepareItems(this.getItems, this.config, columns);
    }

    get getItems(): IAdvertiserManagers[] | [] {
        if (this.advertiser.managers?.length) {
            return this.advertiser.managers.filter(item => !item.is_primary);
        }

        return [];
    }

    get getManagerData(): IBaseAutocomplete {
        return {
            apiMethod: getActiveUserSearch,
            errorText: 'Менеджер не найден',
            placeholder: 'Менеджер',
            itemValue: 'id',
            template: (i: any) => `${i.id} ${i.first_name} ${i.last_name}`,
            multiple: false,
            isChip: true,
        };
    }

    changeManager(id: number): void {
        this.managerId = id;
    }

    async addManager(): Promise<void> {
        if (!this.managerId) return;
        const id = String(this.managerId);
        this.isLoading = true;
        await this.advertiser.addManager(id);
        this.closeModal();
    }

    prepareDeleteForm(manager: IAdvertiserManagers): void {
        this.managerId = manager.id;
        this.managerName = manager.user.full_name!;
        this.isShowDeleteModal = true;
    }

    async deleteManager(): Promise<void> {
        if (!this.managerId) return;
        this.isLoading = true;
        await this.advertiser.deleteManager(this.managerId);
        this.closeModal();
    }

    closeModal(): void {
        this.isLoading = false;
        this.isShowModal = false;
        this.isShowDeleteModal = false;
        this.managerId = null;
        this.managerName = '';
        eventBus.$emit('clear');
    }
}

